<template>
  <div>
     <b-navbar toggleable="md" type="dark" variant="info" class="pt-0 pb-0">
      <div class="container">
        <b-navbar-toggle target="nav_collapse_estudiantes"></b-navbar-toggle>
        <h1 v-if="progreso && progreso.estudiante" class="text-center navbar-brand pt-0 pb-0 mb-0">{{ progreso.estudiante.primer_nombre }} {{ progreso.estudiante.primer_apellido }}</h1>
        <b-collapse is-nav id="nav_collapse_estudiantes">
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <a v-if="progreso && progreso.estudiante" :href="`#/estudiante/detalle/${ progreso.estudiante.id }`" class="nav-link" title="Ver">Volver</a>
            <b-nav-item  href="#" @click="recargar">Actualizar</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
    <div class="container mt-3">
      <div v-if="progreso">
        <h3 class="text-center">Registro Tutorias</h3>
      </div>
      
      <div v-if="progreso">
        <b-row class="text-center mb-3 mt-3 ">
          <b-col cols="1" class="col-md-1"><strong>ID</strong></b-col>
          <b-col cols="3" class="col-md-3"><strong>CLASE</strong></b-col>
          <b-col cols="2" class="col-md-2"><strong>ESTADO</strong></b-col>
          <b-col cols="4" class="col-md-4"><strong></strong></b-col>
        </b-row>
        <ProgresoRegistro v-for="(progreso_fila, index) in progreso.registros" :progreso_fila="progreso_fila" :consecutivo="index" :key="index"/>
      </div>
    </div>     
  </div>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import ProgresoRegistro from '@/components/Estudiantes/ProgresoTutoria/ProgresoRegistro';

import Vue from 'vue';

export default {
    name: 'Progreso',
    components: {
        ProgresoRegistro
    },
    data () {
        return {
            estudiante_id:null,
            curso_id: null,
            definiendoTema:false,
            parcelador:null,
            temaParaDefinir: null,
            reinicioParaDefinir: null,
            niveles_cursados: null,
            niveles_avance: {},
            notas_avance: {},
            motivoDefinirTema: '',
            motivoDefinirTemaMin: 40,
            reinicioDefinir: '',
            reinicioDefinirMin: 40,
            reiniciarSeccion: false,
            nivelar:{
                nota:null,
                edicion:false,
                neditada:null,
                editar:true,
                rango_nota:0
            },
            showNotas:false,
            notasTemas:[],
            vista_ligera:false
        }
    },
    props: {
    },
    mounted () {
        this.estudiante_id = this.$route.params.id;
        this.fetchProgreso({estudiante_id:this.estudiante_id})
        this.verNivelesCursados()
        this.consultarEstadoCurso();
    },
    methods:{
        ...mapActions({
            fetchProgreso: 'tutorias/fetchProgreso',
            revisarProgreso: 'progresos/revisarProgreso',
            fetchEstadoCurso: 'progresos/estadoCurso',
            fetchNotas: 'progresos/fetchNotas',
            actualizarNotas: 'progresos/actualizarNotas',
            actualizarNivelacion: 'progresos/actualizarNivelacion',
            setWarning: 'setWarning',
        }),
        ...mapMutations({
            startProcessing: 'startProcessing',
            stopProcessing: 'stopProcessing'
        }),
        iniciarDefinirTema(){
            this.definiendoTema=true
            if(this.parcelador==null){
              Vue.http.post('estudiante/parcelador',{estudiante_id:this.estudiante_id}).then(
                  response =>{
                      this.parcelador = response.data
                  }
              ).catch(response=>{
                  console.log(response)
              })
            }
        },
        verNivelesCursados(){
            Vue.http.post('estudiante/niveles_cursados',{estudiante_id:this.estudiante_id}).then(
                response =>{
                  this.niveles_cursados = response.data
                }
            ).catch(response=>{
                console.log(response)
            })
        },
        cargarNivel(id){
            Vue.http.post('estudiante/progreso_otro_nivel',{estudiante_id:this.estudiante_id,curso_id:id}).then(
                response =>{
                  Vue.set(this.niveles_avance, response.data.curso_id, response.data.registros, response.data.nota)
                  Vue.set(this.notas_avance, response.data.curso_id, response.data.nota)
                }
            ).catch(response=>{
                console.log(response)
            })
        },
        procesarDefinirTema(){
          this.startProcessing()
          let payload = {
              estudiante_id:this.estudiante_id,
              tema_id:this.temaParaDefinir,
              motivo: this.motivoDefinirTema,
              
            }
            Vue.http.post('progreso/definir_tema',payload).then(response =>{
                console.log(response.data)
            }).catch(response=>{
                console.log(response)
            }).finally(()=>{
                this.definiendoTema=false
                this.stopProcessing()
                this.cancelarDefinirTema()
                this.recargar()
            })
        },
        procesarReinicio(){
            this.startProcessing()
            // this.procesado = true
            let reinicioN = {
                estudiante_id:this.estudiante_id,  
                obs_reinicio:this.reinicioDefinir
            }
            Vue.http.post('progreso/reiniciar_nivel', reinicioN).then()
            .catch(error=>{
                this.setWarning(error.data.error)
            }).finally(()=>{
                this.stopProcessing()
                this.cancelarReinicio()
                this.recargar()
            })
        },
        cancelarDefinirTema(){
            this.temaParaDefinir = null
            this.motivoDefinirTema = ''
        },
        cancelarReinicio(){
            this.reinicioParaDefinir = null
            this.reinicioDefinir = ''
        },
        recargar(){
          console.log(this.progreso)
            this.fetchProgreso({estudiante_id:this.estudiante_id})
            this.consultarEstadoCurso();
        },
        revisar(){
            this.revisarProgreso({estudiante_id:this.estudiante_id}).then(()=>{
                this.recargar()
            })
        },
        consultarEstadoCurso(){
            this.fetchEstadoCurso({estudiante_id:this.estudiante_id}).then((result)=>{
              this.curso_id = result.curso_id;
              if (result.dato && result.dato.nota_nivelacion) {
                this.nivelar.nota = result.dato.nota_nivelacion;
                this.nivelar.nota_final = result.dato.nota_final;
                this.nivelar.editar = false;
              }
                if (result.codigo == 'nivelar') {
                  this.nivelar.id = result.dato ? result.dato.id : null;
                  this.nivelar.editar = true;
                  this.nivelar.rango_nota = result.rango_nota;
                }
            })
        },
        notaNivelacion() {
          this.nivelar.edicion = true;
        },
        cancelarNivelacion() {
          this.nivelar.edicion=false;
          this.nivelar.neditada=null;
        },
        procesarNivelacion() {
          var data = {estudiante_id:this.estudiante_id,nota:this.nivelar.neditada, registro_id:this.nivelar.id}
          this.actualizarNivelacion(data).then((data) => {
            console.log(data);
              if (data.mensaje) {
                  this.$bvToast.toast(data.mensaje, {
                      title: 'Proceso exitoso',
                      autoHideDelay: 5000
                  })
              }
              if (data.dato) {
                this.nivelar.nota = data.dato.nota_nivelacion;
                this.nivelar.nota_final = data.dato.nota_final;
                this.nivelar.editar = false;
                this.cancelarNivelacion();
              }
              this.revisar();
          }).catch((error) => {
              console.error(error)
          })

        },
        convertirJson(json){
            if(json.estructura != null)
                json.estructura = JSON.parse(json.estructura);
            if(json.notas != null)
                json.notas = JSON.parse(json.notas);
            return json
        },
        notaNivel(registros){
            if(registros){
                let temasConNotas = registros.filter(element=>{
                    return element.rango_nota && element.peso_nota
                })
                let notaF = 0;
                for (let i in temasConNotas){
                    let tema = temasConNotas[i]
                    let notaParcial = (tema.nota / tema.rango_nota) * tema.peso_nota
                    notaParcial = notaParcial.toPrecision(3)*1
                    notaParcial = notaParcial*5/100
                    notaF += notaParcial
                }
                return notaF.toPrecision(3);  
            }
            return null
        }, 
        notaMostrar() {
          this.consultarNotas(this.estudiante_id)
        },
        consultarNotas(estudiante_id) {
            this.fetchNotas({estudiante_id:estudiante_id}).then((result) => {
                this.showNotas = true;
                this.notasTemas = result;
            }).catch((error) => {
                console.error(error)
            })
        },
        procesarNotas() {
            var data = {estudiante_id:this.estudiante_id,temas:this.notasTemas}
            this.actualizarNotas(data).then(() => {
                if (data.mensaje) {
                    this.$bvToast.toast(data.mensaje, {
                        title: 'Proceso exitoso',
                        autoHideDelay: 5000
                    })
                }
                this.revisar();
            }).catch((error) => {
                console.error(error)
            })
        },
        cancelarNotas() {
          console.log("cancelar");
        },
        maxValue(tema) {
            if (tema.nota > tema.rango_nota) {
                tema.nota = tema.rango_nota;
            }
        },
        ubicacion(salon, fecha){
            var fec = ""
            var ho = "";
            var sede = ""
            if(fecha != null && fecha != ""){
                fec = fecha.split('T')[0]
                ho = new Date(fecha);
                fecha = fec.split("-")[2] + "/"+ fec.split("-")[1] + "/" + fec.split("-")[0] + " " + ho.getHours()+":"+ho.getMinutes()+":"+ho.getSeconds();
            }else{
              fecha=""
            }
            if(salon!=null)
                sede = JSON.parse(salon).sede
            else
                sede = ""
            return  sede +" "+ fecha;
        },
        docent(progreso){
            if(progreso && progreso.docente){
                if(progreso.docente != null){
                    var docente = JSON.parse(progreso.docente)
                    return docente.nombre
                }else{return "";}
            }
            else{return "";}
        },
        dateFormat(date) {
          return this.$moment(date).format("DD/MM/YYYY h:mm:ss a");
        }
        
    },
    computed: {
        ...mapState({
          progresos: state => state.tutorias.progresos,
          detalle: state => state.estudiantes.detalle, 
        }),
        ...mapGetters({
            getProgreso: 'tutorias/getProgreso', 
            permiso: 'auth/permiso', 
        }),
        estudiante(){
            return this.detalle[this.estudiante_id]
        }, 
        progreso(){
            if(this.estudiante_id){
                return this.getProgreso(this.estudiante_id)
            }
            return null
        },
        texto_estudiante(){
            let texto = ''
            if(this.progreso){
                texto += this.progreso.primer_nombre?this.progreso.primer_nombre:''
                texto += this.progreso.segundo_nombre?' '+this.progreso.segundo_nombre:''
                texto += this.progreso.primer_apellido?' '+this.progreso.primer_apellido:''
                texto += this.progreso.segundo_apellido?' '+this.progreso.segundo_apellido:''
            }
            return texto
        },
        puedeEditarNivelacion() {
          return this.nivelar.editar;
            // if(this.nivelar.nota && this.nivelar.nota >= 0 
            //   && this.nivelar.nota <= this.nivelar.rango_nota
            //   ){
            //     return true;
            // }
            // return false
        },
        instruccionesNota(){
            return '0-'+this.nivelar.rango_nota
        },
        notaFinal(){
            if(this.progreso && this.progreso.progresos){
                let temasConNotas = this.progreso.progresos.filter(element=>{
                  return element.rango_nota && element.peso_nota
                })
                let notaF = 0;
                for (let i in temasConNotas){
                    let tema = temasConNotas[i]
                    let notaParcial = (tema.nota / tema.rango_nota) * tema.peso_nota
                    notaParcial = notaParcial.toPrecision(3)*1
                    notaParcial = notaParcial*5/100
                    notaF += notaParcial
                }
                return notaF.toPrecision(3);  
            }
            return null
        },
        notaFinalTemp(){
            if(this.notasTemas && this.notasTemas){
                let temasConNotas = this.notasTemas.filter(element=>{
                    return element.rango_nota && element.peso_nota
                })
                let notaF = 0;
                for (let i in temasConNotas){
                    let tema = temasConNotas[i]
                    let notaParcial = (tema.nota / tema.rango_nota) * tema.peso_nota
                    notaParcial = notaParcial.toPrecision(3)*1
                    notaParcial = notaParcial*5/100
                    notaF += notaParcial 
                }
                return notaF.toPrecision(3);	
            }
            return null
        },
        opcionesParaDefinirTema(){
            if(this.parcelador){
                let opciones = this.parcelador.map(element=>{
                  return {value:element.id, text:element.nombre}
                })
                return opciones
            }
            return []
        },
        puedeProcesarNotas() {
            if(this.notasTemas.filter(x => x.nota && x.tipo == 'autonomo').length == this.notasTemas.filter(x => x.tipo == 'autonomo').length) {
                return true;
            }
            return false
        }
    }
}
</script>

<style scope>
.headers{

}
.input-nota{
	width: 60px !important;
    display: inline !important;
    margin-right: 10px;
}
</style>